// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Search = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Search = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Search = _exports.Search = function Search(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.5535 8.47787C13.5535 7.1312 13.0186 5.83969 12.0663 4.88744C11.1141 3.9352 9.82259 3.40024 8.47592 3.40024C7.12925 3.40024 5.83773 3.9352 4.88549 4.88744C3.93325 5.83969 3.39829 7.1312 3.39829 8.47787C3.39829 9.82454 3.93325 11.1161 4.88549 12.0683C5.83773 13.0205 7.12925 13.5555 8.47592 13.5555C9.82259 13.5555 11.1141 13.0205 12.0663 12.0683C13.0186 11.1161 13.5535 9.82454 13.5535 8.47787ZM12.5729 13.6539C11.4495 14.5456 10.0246 15.0788 8.47592 15.0788C4.82955 15.0788 1.875 12.1242 1.875 8.47787C1.875 4.8315 4.82955 1.87695 8.47592 1.87695C12.1223 1.87695 15.0768 4.8315 15.0768 8.47787C15.0768 10.0265 14.5437 11.4515 13.6519 12.5749L17.9013 16.8242C18.1996 17.1225 18.1996 17.6049 17.9013 17.9C17.603 18.1952 17.1206 18.1984 16.8254 17.9L12.5729 13.6539Z",
      fill: "currentColor"
    }));
  };
});
